<mat-nav-list class="bottom-sheet-confirm">
  <button mat-raised-button class="btn-danger" (click)="onCancel($event)">CANCELAR</button>
  <button mat-raised-button class="btn-primary" (click)="onConfirm($event)">CONFIRMAR</button>
</mat-nav-list>
